<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="addBanner" size="mini"
      >添加</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="添加Banner"
      width="800px"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="bannerDetail"
        ref="bannerForm"
        class="banner-form"
        :rules="rules"
        label-width="180px"
      >
        <!-- <el-form-item label="广告位置：" prop="type">
          <el-select v-model="bannerDetail.type" placeholder="请选择">
            <el-option
              v-for="item in positionTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>-->
        <div class="flex_div">
          <el-form-item label="场景：" prop="type">
            <el-select v-model="bannerDetail.type" placeholder="请选择">
              <el-option
                v-for="item in bannerTypes"
                :key="item.type"
                :label="item.message"
                :value="item.type"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型：" prop="bannertype">
            <el-select v-model="bannerDetail.bannerType" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <!-- <el-form-item label="商户：" prop="tenantId">
          <el-select v-model="bannerDetail.tenantId">
            <el-option
              v-for="item in tentIdlist"
              :key="item.id"
              :label="item.tenantName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="标题：" prop="title">
          <el-input v-model="bannerDetail.title"></el-input>
        </el-form-item>

        <el-form-item label="图片：" prop="imageUrl">
          <upload
            v-model="bannerDetail.imageUrl"
            :data="selectesQuery"
          ></upload>
        </el-form-item>
        <el-form-item label="跳转地址：" prop="linkUrl">
          <!-- code  symbol linkUrl?linkUrl:code+symbol -->
          <el-radio v-model="bannerDetail.jumpOption" :label="1">URL</el-radio>
          <el-radio v-model="bannerDetail.jumpOption" :label="2"
            >功能页面</el-radio
          >
          <el-input
            v-model="bannerDetail.linkUrl"
            v-if="bannerDetail.jumpOption === 1"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="页面"
          prop="code"
          v-if="bannerDetail.jumpOption === 2"
        >
          <el-select v-model="bannerDetail.page">
            <el-option
              v-for="item in codeList"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="参数"
          prop="symbol"
          v-if="bannerDetail.jumpOption === 2"
        >
          <el-input
            v-model="bannerDetail.params"
            type="textarea"
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('bannerForm')"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Upload from 'components/upload'
import { CODE_LIST } from '../../constants'

export default {
  name: 'CreateBanner',
  props: ['value'],
  data() {
    return {
      dialogVisible: false,
      bannerDetail: {
        type: '',
        bannerType: '',
        tenantId: '',
        title: '',
        imageUrl: '',
        linkUrl: '',
        page: '',
        params: '',
        jumpOption: 1,
      },
      selectesQuery: {},
      rules: {
        title: [{ required: true, message: '标题不能为空！' }],
        tenantId: [{ required: true, message: '商户不能为空！' }],
        imageUrl: [{ required: true, message: '图片不能为空！' }],
      },
      options: [
        {
          value: 'image',
          label: '图片',
        },
        {
          value: 'custom',
          label: '自定义',
        },
      ],

      codeList: CODE_LIST,
    }
  },
  components: {
    Upload,
  },
  watch: {
    jumpOption(newVal, oldVal) {
      this.bannerDetail.linkUrl = ''
      this.bannerDetail.page = ''
      this.bannerDetail.params = ''
    },
  },
  computed: {
    ...mapState('settingBanner', [
      'positionTypeList',
      'platformTypeList',
      'languageList',
      'query',
      'bannerTypes',
      'tentIdlist',
    ]),
    ...mapGetters('settingBanner', ['bannerList']),
  },
  methods: {
    ...mapActions('settingBanner', ['create', 'list']),
    closeDialog() {
      this.dialogVisible = false
      this.bannerDetail = {}
      this.$refs['bannerForm'].resetFields()
    },
    addBanner() {
      this.dialogVisible = true
      this.selectesQuery = {
        category: this.query.category,
        language: this.query.language,
        platform: this.query.platform,
      }
    },
    handleSave(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await this.create({ ...this.query, ...this.bannerDetail })
          if (res.code == 0) {
            this.$message({
              message: '添加成功！',
              type: 'success',
            })
            this.dialogVisible = false
            this.$emit('refresh')
          }
        }
      })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
  },
}
</script>
<style lang="less" src="@/styles/button.less" scoped></style>

<style lang="less" scoped>
.banner-form {
  margin-right: 100px;
}
.flex_div {
  display: flex;
}
</style>
